export default __webpack_public_path__ + "84c3e422f47f4b439cd9f9ad1c6b0419.glb";